module.exports = __webpack_public_path__ + "static/event_danal_webinar_mobile_bg@2x-3ab9c8082a36edbc9dd21fb2de3e62d2.png";